import { HttpAdapter } from "../main/adapters/HttpAdapter";

export class AssistantHttpGateway {
    HttpAdapter = new HttpAdapter();
    constructor() {
        this.baseUrl = `${publicSettings.aws.baseUrls.assistant}/assistant`;
    }

    async getSetting({ name }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/get-setting`,
                { name }
            );

            return response;
        } catch (error) {
            throw new Error(error?.message || "Erro ao buscar setting");
        }
    }

    async sendFeedback({ userId, accountingId, feature, description }) {
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrl}/send-feedback`,
                {
                    userId,
                    accountingId,
                    feature,
                    description
                }
            );
            return response;
        } catch (error) {
            throw new Error(error?.message);
        }
    }
}
